import React from 'react';
import { History } from 'history';
import BaseView from '../base/base-view.component';
import Model from './app-model';
import SectionViewPublic from '../section/section-view-public.component';
import AppService from '../../services/app.service';

interface IProps {
  history: History;
  onLoad?: (data: any) => void;
}

interface IState {
  datarow: Model;
}

export default class AppViewHome extends React.Component<IProps, IState> {
  
  constructor(props: IProps) {
    super(props);
    this.state = {
      datarow: Model.defaultValue(),
    }
  }

  private onLoad = (data: any) => {
    this.setState({datarow: data});
  }

  public render(): React.ReactNode {
    return (
      <BaseView id={+AppService.appId()} caption=' '
        model={Model} onLoad={this.onLoad} disableBackButton disableCard>

        <SectionViewPublic history={this.props.history} id={this.state.datarow?.section} onLoad={this.props.onLoad} />
      </BaseView>
    ) 
  }
}